<template lang="pug">
.event-image-clipper
  b-modal(ref="modal" size="lg" no-close-on-backdrop=true no-close-on-esc=true @ok="onRegister" @cancel="onCancel")
    div(slot="modal-title")

    .clipper
      VueCropper(
        v-show="src"
        ref="cropper"
        dragMode="move"
        :src="src"
        :guides="false"
        :zoomOnTouch="false"
        :zoomOnWheel="false"
        :aspectRatio="ratio"
        :initialAspectRatio="ratio"
        :cropBoxResizable="true"
        :img-style="{ 'width': '766px', 'height': '440px' }"
        :ready="ready"
      )
    .slider(v-show="showSlider")
      label(for="zoom") スライドで画像を拡大できます。
      b-form-input(id="zoom" v-model="zoomRatio" type="range" :min="zoomRatioMin" :max="zoomRatioMax" step="0.0001")

    div(slot="modal-footer" slot-scope="{ ok, cancel }")
      button.btn.modal-ok-btn(type="button" @click="ok()") OK
      button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Watch, Prop, Vue } from "vue-property-decorator";
import VueCropper from "vue-cropperjs";
import FileReaderWrapper from "@/commons/utils/FileReaderWrapper";

@Component({
  components: {
    VueCropper
  }
})
export default class ImageClipper extends Vue {
  /** 切り取り枠のアスペクト比(横) */
  @Prop({
    default: () => {
      return 1;
    }
  })
  private ratio!: number;
  /** 画像格納場所 */
  private src: any = "";
  /** 拡大率 */
  private zoomRatio: string = "1";
  /** 最大拡大率 */
  private zoomRatioMin: string = "1";
  /** 最小拡大率 */
  private zoomRatioMax: string = "1";
  /** 拡大用スライダーの表示可否 */
  private showSlider: boolean = true;

  /**
   * cropperjsのreadyイベントフック
   */
  private ready() {
    const cropper: any = this.$refs.cropper;

    var imageData = cropper.getImageData();
    var zoomRatioMin = imageData.width / imageData.naturalWidth;

    this.zoomRatioMin = zoomRatioMin.toFixed(4);
    this.zoomRatio = zoomRatioMin.toFixed(4);
    cropper.zoomTo(this.zoomRatio);

    // 画像が表示領域(600*400)より小さい場合、スライダーは非表示
    this.showSlider = true;
    if (1 <= Number(this.zoomRatioMin)) {
      this.showSlider = false;
    }

    return;
  }

  /**
   * モーダル表示
   */
  public async show(newFile: File): Promise<void> {
    const modal: any = this.$refs.modal;
    modal.show();

    this.src = await FileReaderWrapper.readAsDataURL(newFile);
    const cropper: any = this.$refs.cropper;
    cropper.replace(this.src);

    return;
  }

  /**
   * 拡大・縮小スライダーの値変更イベントフック
   */
  @Watch("zoomRatio")
  private changeZoomRate(): void {
    const cropper: any = this.$refs.cropper;
    cropper.zoomTo(this.zoomRatio);

    return;
  }

  /**
   * OKボタン押下イベント
   */
  private onRegister(): void {
    const cropper: any = this.$refs.cropper;
    const cropImg = cropper
      .getCroppedCanvas({
        width: "906",
        height: "600",
        fillColor: "#fff",
        imageSmoothingEnabled: true,
        imageSmoothingQuality: "medium"
      })
      .toDataURL("image/jpeg");

    this.$emit("register", cropImg);

    return;
  }

  /**
   * キャンセルボタン押下イベント
   */
  private onCancel(): void {
    this.$emit("cancel");

    return;
  }
}
</script>
<style lang="scss" scoped>
.event-image-clipper {
  .clipper {
    margin-bottom: 12px;
  }
}
</style>
